module.exports = __webpack_public_path__ + "img/icon_read_gray.26fc779a.svg";